/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

export type AdminV1OrganizationsPaymentsLogListType = typeof AdminV1OrganizationsPaymentsLogListType[keyof typeof AdminV1OrganizationsPaymentsLogListType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminV1OrganizationsPaymentsLogListType = {
  booking: 'booking',
  invoice: 'invoice',
  membership: 'membership',
  registration: 'registration',
  terminal: 'terminal',
} as const;
